// Supabase client for store and admin
// Uses anon key; RLS enforces public read vs admin write
//
// Values are injected at build time (vite.config: .env VITE_* or fallback from .dev.vars
// SUPABASE_URL / SUPABASE_ANON_KEY). Worker secrets alone do not fill the SPA bundle.
//
// If VITE_* are empty, we still construct a client with placeholders so the SPA boots (landing, etc.).
// Store/admin features then fail at runtime until the bundle is built with real VITE_SUPABASE_*.

import { createClient } from '@supabase/supabase-js';
import {
  SUPABASE_PLACEHOLDER_ANON_KEY,
  SUPABASE_PLACEHOLDER_URL,
} from '@/lib/constants';

const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL ?? '').trim();
const supabaseAnonKey = String(import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim();

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

const effectiveUrl = isSupabaseConfigured ? supabaseUrl : SUPABASE_PLACEHOLDER_URL;
const effectiveKey = isSupabaseConfigured ? supabaseAnonKey : SUPABASE_PLACEHOLDER_ANON_KEY;

if (import.meta.env.DEV && !isSupabaseConfigured) {
  console.warn(
    '[Padmora] Supabase: VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — placeholder client. Set them for the Vite build (e.g. .env or Cloudflare Build variables).',
  );
}

export const supabase = createClient(effectiveUrl, effectiveKey);
